itsoftApp.createModule("honeycomb", function () {
    const honeycomb = document.querySelector(".js-honeycomb");
    const bg = document.querySelector(".intro__bg");

    if (!honeycomb) {
        return;
    }

    const onHoneycombClick = function (evt) {
        const target = evt.target;

        honeycomb.removeEventListener("mouseover", onHoneycombOver);
        honeycomb.addEventListener("mouseover", onHoneycombMouseDownOver);
        document.addEventListener('mouseup', onHoneycombMouseup);

        if (target.tagName.toLowerCase() == 'path') {
            target.classList.remove("js-animated");
            target.classList.add("js-active");
        }
    }

    const onHoneycombMouseup = function () {
        honeycomb.removeEventListener("mouseover", onHoneycombMouseDownOver);
        document.removeEventListener('mouseup', onHoneycombMouseup);
        honeycomb.addEventListener("mouseover", onHoneycombOver);
    }

    const onHoneycombMouseDownOver = function (evt) {
        const target = evt.target;

        if (target.tagName.toLowerCase() == 'path') {
            target.classList.remove("js-animated");
            target.classList.add("js-active");
        }
    }

    const onHoneycombOver = function (evt) {
        const target = evt.target;
        if (!bg.classList.contains("entered")) {
            bg.classList.add("entered");
        }

        if (target.tagName.toLowerCase() == 'path') {
            target.classList.add("js-animated");
            target.classList.add("js-hover");
        }
    }

    const onHoneycombOut = function (evt) {
        const target = evt.target;

        if (target.tagName.toLowerCase() == 'path') {
            target.classList.remove("js-hover");
        }
    }

    honeycomb.addEventListener("mousedown", onHoneycombClick);
    honeycomb.addEventListener("mouseover", onHoneycombOver);
    honeycomb.addEventListener("mouseout", onHoneycombOut);
});